
import BSelect from 'Src/js/components/blain-form/BSelect.vue';
import LookupRadio from './LookupRadio.vue';
import LookupRadioButton from './LookupRadioButton.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'VehicleAttributeSelector',
	components: {
		BSelect,
		LookupRadio,
		LookupRadioButton,
	}
})
class VehicleAttributeSelector<T extends string | boolean> extends Vue {
	@Prop()
	value: T;

	@Prop({ type: Array as PropType<T[]>, required: true })
	options: T[];

	@Prop({ type: Number, default: 6 })
	selectThreshold: number;

	// Native selects and radios (the basis for the form components used here) can only have string values.
	// To allow non-string values here, we use `value`'s index as the internal value and accept and emit the
	// actual value at that index
	get selection() {
		const valueIndex = this.options.indexOf(this.value);
		return valueIndex === -1 ? '' : valueIndex.toString();
	}
	set selection(index: string) {
		this.$emit('input', this.options[index]);
	}
}

export default VehicleAttributeSelector;
